import { Component, OnInit,Input,Output } from '@angular/core';

@Component({
  selector: 'app-starrating',
  templateUrl: './starrating.component.html',
  styleUrls: ['./starrating.component.scss']
})
export class StarratingComponent implements OnInit {
  @Input() rating: number = 0; // The current rating value
  @Input() maxStars: number = 5; // The maximum number of stars

  constructor() { }

  ngOnInit(): void {

    const container = document.getElementById('rating-container');
     const itemDiv = document.createElement('div');
    const starsHtml = this.generateStarRatingHTML(this.rating);
    container.innerHTML = `
      
      ${starsHtml}
     
    `;
    // container.appendChild(itemDiv);
  }

//  displayRatings(items: RatedItem[]): void {
//   const container = document.getElementById('rating-container');
//   if (!container) return;

//   items.forEach(item => {
//     const itemDiv = document.createElement('div');
//     const starsHtml = generateStarRatingHTML(item.rating, item.maxRating);
//     itemDiv.innerHTML = `
//       <strong>${item.name}</strong>:
//       ${starsHtml}
//       <span>(${item.rating} out of ${item.maxRating || 5})</span>
//     `;
//     container.appendChild(itemDiv);
//   });
// }
  
   generateStarRatingHTML(rating: number): string {
   var maxRating=this.maxStars;
  let starsHtml = '';
  const fullStar = '<span class="fa fa-star fachecked"></span>';
  const emptyStar = '<span class="fa fa-star"></span>';
  const halfStar = '<span class="fa fa-star-half-alt checked"></span>'; // Requires Font Awesome v5+

  const roundedRating = Math.round(rating * 2) / 2; // Round to nearest 0.5

  for (let i = 1; i <= maxRating; i++) {
    if (i <= roundedRating) {
      starsHtml += fullStar;
    } else if (i - 0.5 === roundedRating) {
      starsHtml += halfStar;
    } else {
      starsHtml += emptyStar;
    }
  }
  return starsHtml;
}
}
